import { handleMessageEmit } from '@/methods/message/handleMessageEmit'

// Constants
import { WS_EVENT_CHAT } from '@/constants/socketEvent'

interface Message {
  socket: any
  value: string
  role: number
  name: string
  headUrl: string
  isHost: boolean
}

export const handleChatSend = ({ socket, value, name, headUrl, role, isHost }: Message) => {
  const extra = {
    name,
    isHost,
  }

  const content = {
    sid: WS_EVENT_CHAT.sid,
    ssid: WS_EVENT_CHAT.GROUP,
    body: {
      msg: value,
      msg_type: 0,
      extra: JSON.stringify(extra), // chat 的 name 不從 from 裡面拿，送的時候改成放在 extra 裡
    },
    from: {
      name,
      head_url: headUrl,
      role,
    },
  }

  handleMessageEmit({ socket, content })
}
